<script>
import axios from "axios";
import simplebar from "simplebar-vue";

import i18n from "../i18n";
import { authComputed } from "@/state/helpers";
import gql from "graphql-tag";
import moment from "moment";
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      userData : {},
      languages: [
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Español",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
    };
  },
  apollo: {
    getAllNotificaciones: {
      query: gql`
        query Notificaciones($estado: Boolean!) {
          getAllNotificaciones(estado: $estado) {
            id
            mensaje
            estado
            userId
          }
        }
      `,
      variables() {
        return {
          // usuario:this.$props.user,
          estado: true,
        };
      },
      pollInterval: 300,
    },
    getAllPagos: {
      query: gql`
        query Notificaciones($fecha_pago: Date!) {
          getAllPagos(fecha_pago: $fecha_pago) {
            id
            monto_pago
            fecha_pago
            estado_detalle
            distribucionPagoId
            distribucion_pago {
              id
              venta {
                id
                no_venta
                total
                cliente {
                  persona {
                    nombre_persona
                    numero_persona
                  }
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          // usuario:this.$props.user,
          fecha_pago: this.customFormatter(new Date()),
        };
      },
      pollInterval: 300,
    },
  },

  components: {
    simplebar,
  },
  
  async mounted () {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    await this.getUserById();
  },
  methods: {
    async getUserById (){
      const response = await axios
        .get(
          process.env.VUE_APP_URL +
            "users/sectById?id=" +
            this.$store.state.authfack.user.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.userData.user = response.data.data.usuario;
          this.userData.tienda = response.data.data.empleado.tienda.nombre_tienda;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async leido(id) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!) {
            notificacionLeida(id: $id) {
              id
            }
          }
        `,
        variables: {
          id: id,
        },
      });
    },
    number(value) {
      if (typeof value != "undefined") return value.length;
    },
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    toggleMenu() {
      const menuBtn = document.getElementById('vertical-menu-btn');
    const navbar = document.querySelector('.navbar-brand-box');
    menuBtn.classList.toggle('collapsed');
    navbar.classList.toggle('collapsed');
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      console.log( this.apiUrl)
      axios.get( this.apiUrl +  "/logout").then(() => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
  computed: {
    ...authComputed,
    
  },
};


</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <!-- Aca esta el logotipo del navbar -->
        <div class="navbar-brand-box">
  <router-link to="/" class="logo">
    <img src="@/assets/logo.png" alt="Logo Multirepuestos San José" class="logo-img">
  </router-link>
</div>



        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>



        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <!-- Notificacion Productos -->
        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span v-if="$apollo.data" class="badge bg-danger rounded-pill">{{
             number(getAllNotificaciones)
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <!-- <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a> -->
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div
                class="d-flex"
                v-for="(n, index) in getAllNotificaciones"
                :key="index"
              >
                <div class="avatar-xs me-3" @click="leido(n.id)">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ "Existencia al limite" }}
                  </h6>
                  <div @click="leido(n.id)" class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ n.mensaje }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <!-- <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-3.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a> -->
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>
        <!-- Notificacion pagos -->
        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-user bx-tada"></i>
            <span v-if="$apollo.data" class="badge bg-danger rounded-pill">{{
              number(getAllPagos)
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <!-- <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a> -->
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div
                class="d-flex"
                v-for="(n, index) in getAllPagos"
                :key="index"
              >
                <img
                  src="@/assets/images/users/avatar-2.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ "Clientes Pendiente de pago" }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1" v-if="n.distribucion_pago.venta.cliente!=null">
                      {{
                        
                        "El cliente " +
                        n.distribucion_pago.venta.cliente.persona
                          .nombre_persona +
                        " tiene una deuda para hoy de: " +
                        money(n.monto_pago) +
                        " Llamarle: " +
                        n.distribucion_pago.venta.cliente.persona.numero_persona
                      }}
                    </p>
                     <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p> 
                  </div>
                </div>
              </div>
            </a>
            <!-- <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-3.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a> -->
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>

        <template>
  <b-dropdown
    right
    variant="black"
    toggle-class="header-item"
    menu-class="dropdown-menu-end"
    class="d-inline-block"
  >
    <template v-slot:button-content>
      <span class="d-inline-block">
        <div>{{ userT.username }} {{ userT.nombre_tienda }}</div>
      </span>
      <i class="mdi mdi-chevron-down d-inline-block"></i>
    </template>
    
    <b-dropdown-item href="/logout" class="text-danger">
      <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
      {{ $t("navbar.dropdown.henry.list.logout") }}
    </b-dropdown-item>
  </b-dropdown>
</template>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>
  </header>
</template>



<style scoped>
@media (max-width: 767px) {
  .dropdown-toggle::after {
    display: inline-block !important;
  }
}
.navbar-brand-box {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: 100%;
  background-color: #2c3e50; /* Ajusta este color para que coincida con tu diseño */
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo-img {
  max-width: 80%;
  height: auto;
  object-fit: contain;
}

/* Para pantallas más pequeñas */
@media (max-width: 768px) {
  .navbar-brand-box {
    padding: 5px;
  }
  
  .logo-img {
    max-width: 70%;
  }
}

/* Para cuando el menú está colapsado */
.navbar-brand-box.collapsed {
  padding: 5px;
}

.navbar-brand-box.collapsed .logo-img {
  max-width: 60%;
}
.navbar-brand-box {
  padding: 5px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

/* Estilo base para móviles */
@media (max-width: 767px) {
  .navbar-brand-box {
    height: 50px;
    width: 50px;
  }
  
  .logo-img {
    max-width: 40px;
  }
}

/* Estilo para tablets */
@media (min-width: 768px) and (max-width: 1023px) {
  .navbar-brand-box {
    height: 70px;
    width: 70px;
  }
  
  .logo-img {
    max-width: 60px;
  }
}

/* Estilo para escritorio */
@media (min-width: 1024px) {
  .navbar-brand-box {
    height: 80px;
    width: auto;
    padding: 10px;
  }
  
  .logo-img {
    max-width: 120px;
  }
}

/* Estilo para pantallas grandes */
@media (min-width: 1440px) {
  .navbar-brand-box {
    height: 100px;
  }
  
  .logo-img {
    max-width: 150px;
  }
}

/* Estado colapsado */
.navbar-brand-box.collapsed {
  width: 60px;
  height: 60px;
}

.navbar-brand-box.collapsed .logo-img {
  max-width: 40px;
}

</style>